import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Col, Row, Spin, Typography, Select, Input as AntInput, Button as AntButton, message, Popconfirm, Icon
} from 'antd';

import { addNetworkEscalationSpoc, fetchEscalationSpoc, removeNetworkEscalationSpoc } from '../../services';
import { SemiboldText } from '../../components/common/Text';
const { Title } = Typography;


const { Option } = Select;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const valueOrUndefined = value => {
  return (value && value.trim() === '') ? undefined : value.trim();
};

const validateEmail = (email) => {
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
};

const validatePhone = (phone) => {
  const regex = /^\d{10}$/;
  return regex.test(phone);
}

class NetworkCenterSpecialistsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      region: 'North',
      ManagerName: '',
      regionManagerContactNumer: '',
      regionManagerEmail: '',
      regionHeadName: '',
      regionHeadEmail: '',
      fetchedSpecialists: [],
      originalSpecialists: [],
      currentSelectedLevelMatrix: 1
    };
    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    this.fetchEscalationSpoclists();
  };

  fetchEscalationSpoclists = () => {
    this.setState({ loading: true });
    fetchEscalationSpoc(this.centerId)
      .then(res => {
        console.log({ res }, '[fetchEscalationSpoc] response');
        const { escalationSpocs } = res;
        this.setState({
          escalationSpocs: escalationSpocs,
        });
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleMatrixSavedDetails = () => {
    const escalationLevel = this.state.currentSelectedLevelMatrix;
    const name = valueOrUndefined(escalationLevel === 1 ? this.state.regionManagerName : this.state.regionHeadName);
    const email = valueOrUndefined(escalationLevel === 1 ? this.state.regionManagerEmail : this.state.regionHeadEmail);
    const phone = valueOrUndefined(this.state.regionManagerContactNumer);
    // input field validations before submission. 
    if (!name) {
      return message.error('Name can not be empty', 3);
    }
    if (!email) {
      return message.error('Email can not be empty', 3);
    }
    if (!validateEmail(email)) {
      return message.error('Invalid Email', 3);
    }
    if (escalationLevel == 1 && !phone) {
      return message.error('Phone number can not be empty', 3);
    }
    if (phone && !validatePhone(phone)) {
      return message.error('Invalid Contact Number', 3);
    }
    this.setState({ loading: true });

    addNetworkEscalationSpoc({
      name: escalationLevel === 1 ? this.state.regionManagerName : this.state.regionHeadName,
      email: escalationLevel === 1 ? this.state.regionManagerEmail : this.state.regionHeadEmail,
      phone: this.state.regionManagerContactNumer,
      region: this.state.region,
      escalationLevel: escalationLevel
    }, this.centerId)
      .then(() => {
        this.fetchEscalationSpoclists(this.centerId);
      })
      .catch((err) => {
        console.log({ err });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleMatrixSpocRemove = (spocId) => {
    this.setState({ loading: true });
    removeNetworkEscalationSpoc(spocId, this.centerId)
      .then(() => {
        this.fetchEscalationSpoclists();
      })
      .catch((err) => {
        console.log({ err });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { loading } = this.state;

    return (
      <React.Fragment>
        <Row type="flex" align="middle" gutter={[16, 16]}>
          <Col span={24}>
            <Title type={2}>Escalation Matrix</Title>
          </Col>
        </Row>
        <div style={{ padding: '10px' }}>
          <AntButton
            onClick={() => this.setState({ currentSelectedLevelMatrix: 1 })}
            type={
              this.state.currentSelectedLevelMatrix == 1 ? 'primary' : 'default'
            }
            style={{ marginRight: '10px' }}
          >
            Add Level 1 Matrix
          </AntButton>
          <AntButton
            onClick={() => this.setState({ currentSelectedLevelMatrix: 2 })}
            type={
              this.state.currentSelectedLevelMatrix == 2 ? 'primary' : 'default'
            }
          >
            Add Level 2 Matrix
          </AntButton>
        </div>

        {loading ? (
          <div>
            <Spin />
          </div>
        ) : (
          <React.Fragment>
            <div style={{ border: '1px solid #E8E8E8', padding: '28px' }}>
              {this.state.currentSelectedLevelMatrix == 1 ? (
                <>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <h4 level={4}>Select Zone</h4>
                      <Select
                        style={{ width: '90%' }}
                        onSelect={(e) => {
                          this.setState({ region: e });
                        }}
                        value={this.state.region}
                      >
                        <Option value="North">North</Option>
                        <Option value="East">East</Option>
                        <Option value="West">West</Option>
                        <Option value="South">South</Option>
                      </Select>
                    </Col>

                    {/* </Row> */}

                    {/* <Row> */}
                    <Col span={12}>
                      <LabelText>Zonal Manager Name</LabelText>
                      <AntInput
                        value={this.state.regionManagerName}
                        onChange={(e) => {
                          this.setState({
                            regionManagerName: e.target.value,
                          });
                        }}
                        placeholder="Zonal Manager Name"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <LabelText>Contact No</LabelText>
                      <AntInput
                        value={this.state.regionManagerContactNumer}
                        onChange={(e) => {
                          this.setState({
                            regionManagerContactNumer: e.target.value,
                          });
                        }}
                        placeholder="Contact No"
                      />
                    </Col>

                    <Col span={12}>
                      <LabelText>Email Address</LabelText>
                      <AntInput
                        value={this.state.regionManagerEmail}
                        onChange={(e) => {
                          this.setState({
                            regionManagerEmail: e.target.value,
                          });
                        }}
                        placeholder="Email Address"
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <LabelText>Zonal Head Name</LabelText>
                      <AntInput
                        value={this.state.regionHeadName}
                        onChange={(e) => {
                          this.setState({
                            regionHeadName: e.target.value,
                          });
                        }}
                        placeholder="Zonal Head Name"
                      />
                    </Col>
                    <Col span={12}>
                      <LabelText>Email Address</LabelText>
                      <AntInput
                        value={this.state.regionHeadEmail}
                        onChange={(e) => {
                          this.setState({
                            regionHeadEmail: e.target.value,
                          });
                        }}
                        placeholder="Email Address"
                      />
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                <Col span={4} offset={20}>
                  <AntButton
                    onClick={() => this.handleMatrixSavedDetails()}
                    type="primary"
                    style={{ margin: '10px' }}
                  >
                    Save Details
                  </AntButton>
                </Col>
              </Row>
            </div>
            <br></br>
            {this.state.escalationSpocs.filter(
              (spoc) => spoc.escalation_level === 1
            ).length ? (
              <h2>
                <b>Level 1</b>
              </h2>
            ) : (
              ''
            )}
            <Row gutter={[16, 16]}>
              {this.state.escalationSpocs
                .filter((spoc) => spoc.escalation_level === 1)
                .map((spoc) => {
                  return (
                    <Col span={12}>
                      <div
                        style={{
                          border: '1px solid #E8E8E8',
                          padding: '20px',
                          width: '90%',
                        }}
                      >
                        <h3>
                          <b>{`${spoc.name} | ${spoc.zone}`}</b>
                        </h3>
                        <h4>{spoc.phone}</h4>
                        <h4>{spoc.email}</h4>
                        <div style={{ position: 'absolute', right: '80px', top: '10px' }}>
                          <Popconfirm
                            title="Are you sure to delete this spoc?"
                            onConfirm={() => this.handleMatrixSpocRemove(spoc.spocId)}
                            onCancel={() => console.log(" cancel the delete modal")}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div style={{ marginTop: '14px' }}>
                              <a
                                href="#"
                                style={{
                                  color: 'red',
                                  marginTop: '10px',
                                  textDecoration: 'underline',
                                }}
                              >
                                <Icon type="delete" style={{ fontSize: '18px' }} theme="outlined" />
                              </a>
                            </div>
                          </Popconfirm>
                        </div>
                      </div>
                    </Col>
                  );
                })}
            </Row>
            <br></br>
            {this.state.escalationSpocs.filter(
              (spoc) => spoc.escalation_level === 2
            ).length ? (
              <h2>
                <b>Level 2</b>
              </h2>
            ) : (
              ''
            )}
            <Row gutter={[16, 16]}>
              {this.state.escalationSpocs
                .filter((spoc) => spoc.escalation_level === 2)
                .map((spoc) => {
                  return (
                    <Col span={12}>
                      <div
                        style={{
                          border: '1px solid #E8E8E8',
                          padding: '20px',
                          width: '90%',
                        }}
                      >
                        <h3>
                          <b>{`${spoc.name}`}</b>
                        </h3>
                        <h4>{spoc.email}</h4>
                        <div style={{ position: 'absolute', right: '80px', top: '10px' }}>
                          <Popconfirm
                            title="Are you sure to delete this spoc?"
                            onConfirm={() => this.handleMatrixSpocRemove(spoc.spocId)}
                            onCancel={() => console.log(" cancel the delete modal")}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div style={{ marginTop: '14px' }}>
                              <a
                                href="#"
                                style={{
                                  color: 'red',
                                  marginTop: '10px',
                                  textDecoration: 'underline',
                                }}
                              >
                                <Icon type="delete" style={{ fontSize: '18px' }} theme="outlined" />
                              </a>
                            </div>
                          </Popconfirm>
                        </div>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default withRouter(
  connect(mapStateToProps)(NetworkCenterSpecialistsScreen)
);
